/* GridCheckboxEditor.js */

"use strict";
/* globals Slick */
const CheckBox = require("@gluenetworks/input_checkbox_control");
const _ = require("lodash");

class GridCheckBoxEditor {
    constructor(args) {
        this.parentContainer = args.container;
        // this.keyCaptureList = [ Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER ];
        this.checkBox = new CheckBox();
        this.initialValue = {};
        this.field = args.column.field;

        let checkBoxCell = document.createElement("div");
        checkBoxCell.classList.add("check-box-cell");
        checkBoxCell.appendChild(this.checkBox.renderer.rootElement);
        this.parentContainer[0].appendChild(checkBoxCell);
        this.grid = args.grid;
    }

    static Formatter(row, cell, value, column, dataContext) {
        let displayinfo = column.fcdColumnDef.displayinfo;
        let displayElem;
        if (value) {
            displayElem = document.createElement("base-icon-gl");
            displayElem.setAttribute("data-icon", "common.check");
        } else {
            displayElem = document.createElement("div");
        }
        displayElem.setAttribute("title", displayinfo.tooltip);
        displayElem.classList.add("grid_check_mark");
        return displayElem.outerHTML;
    }

    _registerListeners() {
        this.checkBox.on("Value", (this._valueChanged = this._valueChanged.bind(this)));
    }

    _unregisterListeners() {
        this.checkBox.removeListener("Value", this._valueChanged);
    }

    destroy() {
        setTimeout(() => {
            this._unregisterListeners();
            this.checkBox.shutdown();
        });
    }

    show() {
        this.checkBox.focus();
    }

    hide() {}

    position(position) {}

    focus() {}

    loadValue(item) {
        this.initialValue = item[this.field];
        this.checkBox.setValue(item[this.field]);
        this._registerListeners();
    }

    getValue() {
        this.checkBox.getValue();
    }

    setValue(value) {
        this.checkBox.setValue(value);
    }

    serializeValue() {
        return this.checkBox.getValue();
    }

    applyValue(item, state) {
        item[this.field] = state;
        this.initialValue = state;
    }

    isValueChanged() {
        return !_.isEqual(this.checkBox.getValue(), this.initialValue);
    }

    validate() {
        return {
            valid: true,
            msg: null,
        };
    }

    _valueChanged() {
        this.grid.getEditController().commitCurrentEdit();
    }
}

module.exports = GridCheckBoxEditor;
